import Vue from 'vue';
import {
  SET_QUEUE_UI_FLAG,
  CLEAR_QUEUES,
  SET_QUEUES,
  SET_QUEUE_ITEM,
  EDIT_QUEUE,
  DELETE_QUEUE,
} from './types';

export const mutations = {
  [SET_QUEUE_UI_FLAG]($state, data) {
    $state.uiFlags = {
      ...$state.uiFlags,
      ...data,
    };
  },

  [CLEAR_QUEUES]: $state => {
    Vue.set($state, 'records', {});
  },

  [SET_QUEUES]: ($state, data) => {
    data.forEach(queue => {
      Vue.set($state.records, queue.id, {
        ...($state.records[queue.id] || {}),
        ...queue,
      });
    });
  },

  [SET_QUEUE_ITEM]: ($state, data) => {
    Vue.set($state.records, data.id, {
      ...($state.records[data.id] || {}),
      ...data,
    });
  },

  [EDIT_QUEUE]: ($state, data) => {
    Vue.set($state.records, data.id, data);
  },

  [DELETE_QUEUE]: ($state, queueId) => {
    const { [queueId]: toDelete, ...records } = $state.records;
    Vue.set($state, 'records', records);
  },
};
